import React from 'react';
import { Box, Text, Link } from '@primer/react';

const Footer = () => {
    return (
        <Box
            as="footer"
            borderTop="1px solid"
            borderColor="border.default"
            pt={4}
            mt={6}
        >
            <Box
                display="flex"
                flexDirection={['column', 'column', 'row']}
                justifyContent="space-between"
                alignItems={['flex-start', 'flex-start', 'center']}
            >

                <Box mt={4}>
                    <Text
                        as="p"
                        color="fg.muted"
                        sx={{ fontSize: 1 }}
                    >
                        Feel free to get in touch: <Link href="mailto:contact@dylanca.dev?subject=Professional%20Inquiry" sx={{ color: 'accent.fg' }}>contact@dylanca.dev</Link> or reach out via <Link href="https://www.linkedin.com/messaging/compose?recipient=dylancattelan" sx={{ color: 'accent.fg' }}>LinkedIn</Link>
                    </Text>
                </Box>
                <Text
                    as="p"
                    mb={[3, 3, 0]}
                    color="fg.muted"
                    sx={{ fontSize: 1 }}
                >
                    © {new Date().getFullYear()} DylanCa. Made with ❤️.
                </Text>
            </Box>
        </Box>
    );
};

export default Footer;